import BaseService from './BaseService';
import entities from 'src/config/entities';
import axios from "axios";
import format from "date-fns/format"
import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'
import FileService from 'src/services/FileService'

class JobService extends BaseService {

  constructor() {
    super({ entity: entities.JOB });
  }


  async getById(jobId) {
    return await super.getById(jobId, {
      'with': 'client,job_boards,followers'
    });
  }

  async getJobPrice(data) {
    return super.instance.post('/price', data);
  }

  async getKpi(jobId, range = 'total') {
    try {
      return await axios.get(`jobs/${jobId}/kpi`, {
        params: {
          date_range: range
        }
      });
    } catch (e) {
      this._handleError({ translationKey: 'generic.get.error', error: e });
      throw e;
    }
  }

  async setJobStatus(id, data) {
    return super.instance.put(`/${id}/status`, data);
  }

  async publishDraftJob(id, data) {
    return super.instance.put(`/${id}/publish/draft`, data);
  }

  async export(data, extension) {
    try {
      let res = await axios.post(`jobs/export/${extension}`, data, {
        responseType: 'blob'
      })

      let fileName = `jobs-${format(new Date(), FRIENDLY_DATETIME_FORMAT)}.${extension}`
      FileService.downloadFileInBrowser(res, fileName)
    } catch (e) {
      this._handleError({ translationKey: 'order.messages.exportError', error: e });
      throw e;
    }
  }


  async updateJobBoards(id, data) {
    return super.instance.put(`/${id}/job-boards`, data)
  }

  async verify(id, data) {
    try {
      let res = await this.instance.put(`/${id}/verify`, data)
      return res.data
    } catch (e) {
      this._handleError({ translationKey: 'job.messages.verifyError', error: e });
      throw e;
    }
  }
  async upSell(id, data) {
    try {
      let res = await this.instance.post(`/${id}/up-sell`, data)
      this._handleSuccess({ translationKey: 'job.messages.upSellSuccess', data});
      return res.data
    } catch (e) {
      this._handleError({ translationKey: 'job.messages.upSellError', error: e });
      throw e;
    }
  }


}

export default new JobService();
